import { Injectable } from '@angular/core';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { TimeZone } from './time-zone.model';
import { TimezoneService } from '../../shared/services/timezone.service';
import * as moment from 'moment';
import { Moment } from 'moment/moment';

@Injectable()
export class DateTimezoneService {

  public defaultTimezone: BehaviorSubject<TimeZone> = new BehaviorSubject(null);
  public tripTimezone: BehaviorSubject<string> = new BehaviorSubject(null);
  public timezoneChange: Observable<TimeZone | string> = merge(this.defaultTimezone, this.tripTimezone);

  public options: TimeZone[] = [];
  public selectedTimeZone: TimeZone;
  public displayTripTimezone = false;

  constructor(private timezoneService: TimezoneService) {
    this.selectedTimeZone = this.createTimezoneFromName(moment.tz.guess());
    this.setAllTimeZonesOptions();
  }

  selectedTimeZoneChange(timezone: TimeZone) {
    if (timezone) {
      this.selectedTimeZone = timezone;
      this.defaultTimezone.next(timezone);
    }
  }

  resetToDefaultTimezone() {
    moment.tz.setDefault();
    const guess = moment.tz.guess();
    const timezone = this.options.find((opt) => opt.zone === guess);
    this.selectedTimeZoneChange(timezone);
  }

  timezoneSourceChange(shouldDisplayTripTimezone: boolean, timezone: string) {
    this.displayTripTimezone = shouldDisplayTripTimezone;
    this.tripTimezone.next(timezone);
  }

  utcToCurrentTimezone(time: Moment) {
    if (time == null) {
      return null;
    }
    if (this.displayTripTimezone) {
      return time.utc().tz(this.tripTimezone.getValue());
    }
    return time.utc().tz(this.defaultTimezone.getValue().zone);
  }

  getTripTime(time: Moment) {
    if (time == null) {
      return null;
    }
    return time.utc().tz(this.tripTimezone.getValue());
  }

  getDefaultTime(time: Moment) {
    if (time == null) {
      return null;
    }
    return time.utc().tz(this.defaultTimezone.getValue().zone);
  }

  private setAllTimeZonesOptions() {
    this.timezoneService.getTimezoneIds().subscribe(timezoneList => {
      this.options = timezoneList.map(zone => this.createTimezoneFromName(zone));
      this.resetToDefaultTimezone();
    });
  }

  private createTimezoneFromName(name: string): TimeZone {
    const abbreviation = moment.tz(name).format('z');
    return new TimeZone(name, name + ' (' + abbreviation + ')', abbreviation);
  }
}
